import api from "!../../../../../../tmp/drone/cache/981e53a81b962eba0212effe8cc0e70d28aa47ea9fa1c123d299ef07d0c11e50/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../tmp/drone/cache/981e53a81b962eba0212effe8cc0e70d28aa47ea9fa1c123d299ef07d0c11e50/node_modules/css-loader/index.js??ruleSet[1].rules[1].use[1]!./yellowHiveCss.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};